import React, { useEffect, useRef, useState } from "react"
import { MdMoreVert } from "react-icons/md"
import styles from "./templatesManager.module.css"

const TemplateCardMenu = ({ actions = [] }) => {
    const [isOpen, setIsOpen] = useState(false)
    const menuRef = useRef(null)

    useEffect(() => {
        if (!isOpen) return undefined

        const handlePointerDown = (event) => {
            if (!menuRef.current?.contains(event.target)) setIsOpen(false)
        }
        const handleKeyDown = (event) => {
            if (event.key === "Escape") setIsOpen(false)
        }

        document.addEventListener("pointerdown", handlePointerDown)
        document.addEventListener("keydown", handleKeyDown)
        return () => {
            document.removeEventListener("pointerdown", handlePointerDown)
            document.removeEventListener("keydown", handleKeyDown)
        }
    }, [isOpen])

    const handleAction = (event, action) => {
        event.stopPropagation()
        setIsOpen(false)
        action.onClick?.()
    }

    return (
        <div className={styles.templateCardMenu} ref={menuRef} onClick={event => event.stopPropagation()}>
            <button
                type="button"
                className={`${styles.templateCardMenuTrigger} ${isOpen ? styles.active : ""}`}
                onClick={() => setIsOpen(previousValue => !previousValue)}
                aria-label="Ações do template"
                aria-haspopup="menu"
                aria-expanded={isOpen}
                title="Ações"
            >
                <MdMoreVert />
            </button>
            {isOpen && <div role="menu">
                {actions.map(action => (
                    <button key={action.label} type="button" role="menuitem" onClick={event => handleAction(event, action)}>
                        {action.label}
                    </button>
                ))}
            </div>}
        </div>
    )
}

export default TemplateCardMenu
